module.exports = __webpack_public_path__ + "img/Arrow.2a46bb9c.svg";